import { AthosFetcher } from 'libs/athos/classes/athos-fetcher'
import { normaliseBlogResults } from 'libs/athos/helpers/normalisers'
import { generateAthosProvider } from 'libs/athos/fetchers/provider'
import type { AthosFetchOptions } from 'libs/athos/athos.types'

export class AthosBlog extends AthosFetcher {
  generateURL() {
    return super.generateURL('/search')
  }

  updateParams(options: AthosFetchOptions = {}) {
    const { handle, originalQuery, sort, filters, page, resultsPerPage } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('bgfilter.blog_handle', handle)

    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)

    if (sort) this.params.setSort(sort)
    else this.params.clearSort()
    if (filters) this.params.setFilters(filters)

    super.updateParams()
  }
}

export class AthosBlogSearch extends AthosFetcher {
  generateURL() {
    return super.generateURL('/search')
  }

  updateParams(options: AthosFetchOptions = {}) {
    const { query, resultsPerPage } = options
    if (!query || query === 'null') return

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('q', query)

    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)

    super.updateParams()
  }
}

const blogNormaliser = async (results: any) => {
  const normalisedResults = await normaliseBlogResults(results.results)
  return { ...results, results: normalisedResults }
}

export const AthosBlogProvider = generateAthosProvider(AthosBlog, blogNormaliser)
export const AthosBlogSearchProvider = generateAthosProvider(AthosBlogSearch, blogNormaliser)
